import React, { Component } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';

import RenderIf from '../../../shared/render-if/components/render-if';

import '../styles/date-range-selector.css';

class DateRangeSelector extends Component {
  state = {
    showPicker: false,
  };

  onDateChange(values) {
    const { onChange } = this.props;
    const startDate = moment(values.selection.startDate);
    const endDate = moment(values.selection.endDate);
    const { showPicker } = this.state;

    this.setState({ showPicker: !showPicker });
    onChange(startDate, endDate);
  }

  render() {
    const { startDate, endDate } = this.props;
    const { showPicker } = this.state;
    const selection = {
      startDate,
      endDate,
      key: 'selection',
    };

    return (
      <div className="date-range-picker-container" id="date-range-picker">
        <div className="date-range-picker-container__header">
          <div className="dates" onClick={() => this.setState({ showPicker: !showPicker })}>
            {moment(startDate).format('MM/DD/YYYY')} - {moment(endDate).format('MM/DD/YYYY')}
          </div>
        </div>
        <RenderIf if={showPicker}>
          <div className="date-range-picker-container__picker">
            <DateRangePicker ranges={[selection]} onChange={this.onDateChange.bind(this)} showSelectionPreview={true} showMonthAndYearPickers={true} />
          </div>
        </RenderIf>
      </div>
    );
  }
}

export default DateRangeSelector;



// WEBPACK FOOTER //
// ./src/app/shared/date-range-selector/components/date-range-selector.js